export const SET_APP_TITLE: string = "SET_APP_TITLE";
